import { useState, useEffect } from 'react';
import MapContainer from './containers/MapContainer';
import styled from 'styled-components/macro';
import WrapperStyles from './styles/WrapperStyles';
import GlobalStyles from './styles/GlobalStyles';



const AppContainer = styled.div`
  position:relative;
  height:100%;
  width:100%; 
`

const TestContent = styled.div`
  padding: 300px 0;
  background:#ddd;
`

function App() {
 
  const [ airtablePins, setAirtablePins ] = useState([]);

  useEffect(() => {
    fetch(`/actions/airtable-connector-module/default`)
          .then((res) => res.json())
          .then((data) => {
            setAirtablePins(data.records);
            // console.log(data);
          })
          .catch((error) => {
            console.log(error);
          });    
    }, []);


  return (
    <AppContainer>
      <GlobalStyles /> 
      <WrapperStyles>
        {/* <TestContent>Content above the map</TestContent> */}
        <MapContainer airtablePins={airtablePins} /> 
        {/* <TestContent>Content below the map</TestContent> */}
      </WrapperStyles>
    </AppContainer>
  );
}

export default App; 
